import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import "../dynamic_applet.scss"

export default class TransactionLogRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      detailsOpen: false,
    }
  }

  toggleDetails = () => {
    this.setState({ detailsOpen: !this.state.detailsOpen })
  }

  requestPath = () => {
    if (this.props.transaction.request) {
      let url = this.props.transaction.request.url
      // remove hostname part
      return url.substring(url.indexOf("/", 8))
    } else {
      return ""
    }
  }

  renderRequestSummary = () => {
    return (
      <>
        {this.props.transaction.request && (
          <>
            {this.props.transaction.request.method}&nbsp;{this.requestPath()}
          </>
        )}
      </>
    )
  }

  renderHeaders = headers => {
    return Object.entries(headers).map(([k, v], i) => {
      return (
        <>
          <code>
            {k}: {v}
          </code>
          <br />
        </>
      )
    })
  }

  render() {
    const transaction = this.props.transaction
    const { request, response } = transaction

    return (
      <section>
        <div
          className={classnames("entry", {
            open: this.state.detailsOpen,
            closed: !this.state.detailsOpen,
          })}
        >
          <div className="entry-summary" onClick={this.toggleDetails}>
            <div styleName="logs-column">
              {new Intl.DateTimeFormat("en-US", {
                month: "long",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              }).format(transaction.ts)}
            </div>
            <div styleName="logs-column">{this.renderRequestSummary()}</div>
            <div styleName="logs-column">{transaction.type}</div>
            <div styleName="logs-column">{response ? response.status : ""}</div>
          </div>
          <div className="entry-details">
            <h5>Transaction</h5>
            <section>
              <p>
                <strong>Request ID</strong>
                <br />
                {transaction.id}
              </p>
              <p>
                <strong>User</strong>
                <br />
                {transaction.remote_user_id}
              </p>
              {transaction.execution && (
                <p>
                  <strong>Execution Time</strong>
                  <br />
                  {transaction.execution.time}
                </p>
              )}
            </section>

            {request && (
              <>
                <h5>Request</h5>
                <section>
                  <p>
                    <strong>Method</strong>
                    <br />
                    {request.method}
                  </p>
                  <p>
                    <strong>URL</strong>
                    <br />
                    {request.url}
                  </p>
                  <p>
                    <strong>Headers</strong>
                    <br />
                    {this.renderHeaders(request.headers)}
                  </p>
                  <p>
                    <strong>Body</strong>
                    <br />
                    <code>{request.body}</code>
                  </p>
                </section>
              </>
            )}

            {response && (
              <>
                <h5>Response</h5>
                <section>
                  <p>
                    <strong>Status</strong>
                    <br />
                    {response.status}
                  </p>
                  <p>
                    <strong>Headers</strong>
                    <br />
                    {this.renderHeaders(response.headers)}
                  </p>
                  <p>
                    <strong>Body</strong>
                    <br />
                    <code>{response.body}</code>
                  </p>
                </section>
              </>
            )}
          </div>
        </div>
      </section>
    )
  }
}

const propTypeRequest = PropTypes.shape({
  method: PropTypes.string,
  url: PropTypes.string,
  headers: PropTypes.objectOf(PropTypes.string),
  body: PropTypes.string,
})

const propTypeResponse = PropTypes.shape({
  status: PropTypes.number,
  headers: PropTypes.objectOf(PropTypes.string),
  body: PropTypes.string,
})

const propTypeExecution = PropTypes.shape({
  time: PropTypes.number,
})

// We don't normally expect missing fields but we should be able to handle any missing field,
// so declaring them all as optional here.
TransactionLogRow.propTypes = {
  transaction: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    ts: PropTypes.number,
    remote_user_id: PropTypes.string,
    execution: propTypeExecution,
    request: propTypeRequest,
    response: propTypeResponse,
  }).isRequired,
}
